import { AlertDialog, Button } from '@smithhealth/design-system';
import { format } from 'date-fns';
import styles from './inactivity-warning-modal.module.scss';
import { useInactivityLogout } from './use-inactivity-logout';

/**
 * Self-contained inactivity warning modal that manages its own state.
 *
 * This component calls useInactivityLogout internally to avoid causing
 * re-renders in the parent component tree. The parent only renders this
 * component once, and all state updates (activity tracking, countdown)
 * are isolated to this component.
 *
 * Note: The feature flag check should be done at the parent level to avoid
 * loading this component and its hooks when the feature is disabled.
 */
export const InactivityWarningModal = () => {
  const { isWarningVisible, timeUntilLogout, handleContinue, handleLogout } =
    useInactivityLogout();

  if (!isWarningVisible) {
    return null;
  }

  return (
    <AlertDialog
      title="Session Expiring Soon"
      actions={
        <>
          <Button onClick={handleLogout}>Log Out</Button>
          <Button hierarchy="primary" onClick={handleContinue}>
            Continue Session
          </Button>
        </>
      }
    >
      <p
        className={styles.timer}
        data-testid="countdown-timer"
        aria-live="polite"
        aria-atomic="true"
      >
        {format(timeUntilLogout, 'mm:ss')}
      </p>
      <p className={styles.warning}>
        You’re about to be logged out due to inactivity. Would you like to
        continue this session instead?{' '}
      </p>
    </AlertDialog>
  );
};
